module.exports = __webpack_public_path__ + "media/images/symbols/diagonal-arrow-db51fecf4ed65275ac12c4c465da156d.png";